import { render } from "./App.vue?vue&type=template&id=5d59a962"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5d59a962&lang=scss"

import exportComponent from "/home/runner/work/patient-portal/patient-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__